// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionFieldset_root___mhIA","legend":"SectionFieldset_legend__us_4q"};